export default {
  howDoesItWork: {
    id: 'bo_seller-options-batch_listing_creation-how_does_it_work',
    defaultMessage: 'How does it work?',
  },
  firstPoint: {
    id: 'bo_seller-options-batch_listing_creation-first_point',
    defaultMessage: 'Generate a CSV file template.',
  },
  secondPoint: {
    id: 'bo_seller-options-batch_listing_creation-second_point',
    defaultMessage: 'Download the file.',
  },
  thirdPoint: {
    id: 'bo_seller-options-batch_listing_creation-third_point',
    defaultMessage: 'Enter your listing details.',
  },
  forthPoint: {
    id: 'bo_seller-options-batch_listing_creation-forth_point',
    defaultMessage: 'Upload the final CSV file on the Listings page.',
  },
}
